type BeforeRumSessionStopCallback = () => void

const callbacks = new Set<BeforeRumSessionStopCallback>()

export const onBeforeRumSessionStop = (callback: BeforeRumSessionStopCallback): (() => void) => {
  callbacks.add(callback)
  return () => {
    callbacks.delete(callback)
  }
}

export const notifyBeforeRumSessionStop = (): void => {
  callbacks.forEach((callback) => {
    try {
      callback()
    } catch {
      // Instrumentation must never break the unload path or starve later callbacks
    }
  })
}
